<template>
  <div style="background: #f5f7fa; min-height: 100vh">
    <!-- Header Bar -->
    <!-- <v-app-bar color="white" flat app>
      <v-toolbar-title class="font-weight-bold">
        <v-icon color="primary" left>mdi-clipboard-list-outline</v-icon>
        Loss Adjuster Claims
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>
      <v-avatar color="primary" size="32" class="ml-2">
        <v-icon dark>mdi-account</v-icon>
      </v-avatar>
    </v-app-bar> -->

    <v-container fluid>
      <!-- Compact breadcrumb row -->
      <v-row class="mt-0 mb-1 py-0 px-0 compact-breadcrumb-row">
        <v-col cols="12" class="py-0 px-0">
          <v-breadcrumbs
            :items="breadcrumbs"
            divider=">"
            dense
            class="compact-breadcrumb"
          >
            <template v-slot:item="{ item }">
              <span class="grey--text text--darken-1 compact-breadcrumb-text">{{
                item.text
              }}</span>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <!-- --- Place new dashboard design below this row --- -->
      <v-row>
        <v-col cols="12">
          <!-- --- Begin new dashboard layout --- -->
          <!-- Summary Cards -->
          <v-row class="mb-4">
            <v-col cols="12" sm="6" md="3">
              <v-card class="pa-4" color="white" elevation="2">
                <div class="d-flex align-center">
                  <v-icon color="primary" size="32"
                    >mdi-clipboard-list-outline</v-icon
                  >
                  <div class="ml-3">
                    <div class="caption grey--text">Total Claims</div>
                    <div class="headline font-weight-bold">
                      {{ statusCounts.total }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <!-- The following cards only show counts for the current page, not global counts -->
            <v-col cols="12" sm="6" md="3">
              <v-card class="pa-4" color="white" elevation="2">
                <div class="d-flex align-center">
                  <v-icon color="#FBC02D" size="32">mdi-timer-sand</v-icon>
                  <div class="ml-3">
                    <div class="caption grey--text">Pending</div>
                    <div class="headline font-weight-bold">
                      {{ statusCounts.pending }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card class="pa-4" color="white" elevation="2">
                <div class="d-flex align-center">
                  <v-icon color="#43A047" size="32"
                    >mdi-check-circle-outline</v-icon
                  >
                  <div class="ml-3">
                    <div class="caption grey--text">Approved</div>
                    <div class="headline font-weight-bold">
                      {{ statusCounts.approved }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card class="pa-4" color="white" elevation="2">
                <div class="d-flex align-center">
                  <v-icon color="#E53935" size="32"
                    >mdi-close-circle-outline</v-icon
                  >
                  <div class="ml-3">
                    <div class="caption grey--text">Rejected</div>
                    <div class="headline font-weight-bold">
                      {{ statusCounts.rejected }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Search/Filter/Export Bar -->
          <v-row class="mb-2">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search claims..."
                dense
                outlined
                hide-details
                class="mr-2"
                style="max-width: 350px"
              ></v-text-field>
              <v-btn
                color="primary"
                outlined
                class="ml-2"
                @click="showFilter = !showFilter"
              >
                <v-icon left>mdi-filter-variant</v-icon> Filter
              </v-btn>
              <v-btn color="primary" outlined class="ml-2">
                <v-icon left>mdi-export-variant</v-icon> Export
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn color="primary" class="font-weight-bold" dark>
                <v-icon left>mdi-plus</v-icon> Create New Claim
              </v-btn>
            </v-col>
          </v-row>
          <v-expand-transition>
            <v-card v-if="showFilter" class="mb-4 pa-4" outlined>
              <!-- Example filter controls -->
              <v-row>
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="filterStatus"
                    :items="statusOptions"
                    label="Status"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filterDate"
                        label="Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterDate"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card>
          </v-expand-transition>

          <!-- Tabs for claim status with global count badges -->
          <v-tabs
            v-model="activeTab"
            background-color="transparent"
            grow
            class="mb-2"
          >
            <v-tab v-for="tab in tabs" :key="tab.value" class="text-capitalize">
              <span>
                {{ tab.label }}
                <v-badge
                  :content="statusCounts[tab.value] !== undefined ? statusCounts[tab.value] : 0"
                  color="primary"
                  overlap
                  class="ml-2"
                  bordered
                  v-if="statusCounts[tab.value] !== undefined"
                ></v-badge>
              </span>
            </v-tab>
          </v-tabs>

          <!-- Claims Table -->
          <v-card class="elevation-2" style="background: #fff">
            <v-data-table
              :headers="headers"
              :items="filteredClaims()"
              :loading="loading"
              class="elevation-0"
              :items-per-page="pagination.size"
              :footer-props="{
                'items-per-page-options': [10, 20, 50],
                'show-current-page': true,
                'show-first-last-page': true,
                'items-per-page-text': 'Rows per page',
              }"
              :hide-default-footer="false"
              :show-select="false"
              dense
              :item-class="getRowClass"
              @click:row="onRowClick"
              @pagination="({ page, itemsPerPage }) => { onPageChange(page); onPageSizeChange(itemsPerPage); }"
            >
              <template v-slot:[`item.caseId`]="{ item }">
                <span class="font-weight-medium">
                  {{ formatAasbRef(item.caseId) }}
                </span>
              </template>
              <template v-slot:[`item.adjId`]="{ item }">
                <span
                  v-for="adjuster in filterUser(item.adjId)"
                  :key="adjuster.id"
                  class="blue--text text--darken-2"
                >
                  {{ adjuster.username }}
                </span>
              </template>
              <template v-slot:[`item.sumAll`]="{ item }">
                <span class="font-weight-bold">MYR {{ total(item.id) }}</span>
              </template>
              <template v-slot:[`item.createdAt`]="{ item }">
                <span class="grey--text">{{ formatDate(item.createdAt) }}</span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn small color="success" text @click.stop="dummyActionFromTable('approve', item)">
                  <v-icon left small>mdi-check</v-icon>Approve
                </v-btn>
                <v-btn small color="warning" text @click.stop="dummyActionFromTable('query', item)">
                  <v-icon left small>mdi-comment-question</v-icon>Query
                </v-btn>
                <v-btn small color="error" text @click.stop="dummyActionFromTable('close', item)">
                  <v-icon left small>mdi-close</v-icon>Close
                </v-btn>
              </template>
            </v-data-table>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.totalPages"
              @input="onPageChange"
              class="my-2"
              color="primary"
              circle
              total-visible="7"
            ></v-pagination>
          </v-card>
          <!-- --- End new dashboard layout --- -->

          <!-- Claim Details Dialog -->
          <v-dialog v-model="detailsDialog" max-width="600px">
            <v-card>
              <v-card-title class="headline font-weight-bold">
                Claim Details
              </v-card-title>
              <v-card-text v-if="selectedClaim">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">AASB Reference</v-list-item-title>
                      <v-list-item-subtitle>{{ formatAasbRef(selectedClaim.caseId) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">Adjuster</v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-for="adjuster in filterUser(selectedClaim.adjId)" :key="adjuster.id">
                          {{ adjuster.username }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">Submitted On</v-list-item-title>
                      <v-list-item-subtitle>{{ formatDate(selectedClaim.createdAt) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">Claims Total</v-list-item-title>
                      <v-list-item-subtitle>MYR {{ total(selectedClaim.id) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-2">Status</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-chip :color="statusColor(selectedClaim.isApproved)" dark small>
                          {{ statusLabel(selectedClaim.isApproved) }}
                        </v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Add more fields as needed -->
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="dummyAction('approve')">
                  <v-icon left small>mdi-check</v-icon> Approve
                </v-btn>
                <v-btn color="warning" text @click="dummyAction('query')">
                  <v-icon left small>mdi-comment-question</v-icon> Query
                </v-btn>
                <v-btn color="error" text @click="dummyAction('close')">
                  <v-icon left small>mdi-close</v-icon> Close
                </v-btn>
                <v-btn color="grey" text @click="detailsDialog = false">
                  <v-icon left small>mdi-close-circle</v-icon> Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MemberDataService from "../../services/MemberDataService";
import CasefileDataService from "../../services/CasefileDataService";
import BranchDataService from "../../services/BranchDataService";
import DeptDataService from "../../services/DeptDataService";
import SubRefTypeDataService from "../../services/SubDeptDataService";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "claimListV2",
  data() {
    return {
      activeTab: 0,
      tabs: [
        { label: "New", value: "new" },
        { label: "Pending", value: "pending" },
        { label: "Query", value: "query" },
        { label: "Approved", value: "approved" },
      ],
      headers: [
        { text: "AASB REFERENCE", value: "caseId" },
        { text: "ADJUSTER", value: "adjId" },
        { text: "SUBMITTED ON", value: "createdAt" },
        { text: "CLAIMS TOTAL", value: "sumAll" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      casefiles: [],
      refType: [],
      subRefTypes: [],
      branches: [],
      members: [],
      search: "",
      showFilter: false,
      filterStatus: null,
      filterDate: null,
      menu: false,
      statusOptions: [
        { text: "All", value: null },
        { text: "New", value: 0 },
        { text: "Query", value: 1 },
        { text: "Approved", value: 2 },
        { text: "Pending", value: 3 },
        { text: "Rejected", value: 4 },
      ],
      breadcrumbs: [
        { text: "Home" },
        { text: "Claims" },
        { text: "Loss Adjuster Claims" },
      ],
      detailsDialog: false,
      selectedClaim: null,
      statusTabMap: {
        new: 0,
        pending: 3,
        query: 1,
        approved: 2,
      },
    };
  },
  computed: {
    ...mapGetters("claimsV2", [
      "allClaimsV2",
      "claimsV2Loading",
      "claimsV2Pagination",
      "claimsV2StatusCounts"
    ]),
    claims() {
      return this.allClaimsV2;
    },
    loading() {
      return this.claimsV2Loading;
    },
    pagination() {
      return this.claimsV2Pagination;
    },
    statusCounts() {
      return this.claimsV2StatusCounts;
    },
    activeTabValue() {
      return this.tabs[this.activeTab]?.value || "new";
    },
    casefileMap() {
      return Object.fromEntries(this.casefiles.map((cf) => [cf.id, cf]));
    },
    deptMap() {
      return Object.fromEntries(this.refType.map((d) => [d.id, d]));
    },
    subDeptMap() {
      return Object.fromEntries(this.subRefTypes.map((s) => [s.id, s]));
    },
    branchMap() {
      return Object.fromEntries(this.branches.map((b) => [b.id, b]));
    },
    memberMap() {
      return Object.fromEntries(this.members.map((m) => [m.id, m]));
    },
  },
  created() {
    this.fetchAllData(1, 20, this.activeTabValue);
  },
  methods: {
    ...mapActions("claimsV2", ["fetchClaimsV2"]),
    async fetchAllData(page = 1, size = 20, tab = this.activeTabValue) {
      this.$store.commit("claimsV2/SET_LOADING", true);
      // Always send isApproved for every tab (including "new")
      const params = { page, size, isApproved: this.statusTabMap[tab] };
      await Promise.all([
        this.fetchClaimsV2(params),
        this.fetchCasefiles(),
        this.fetchRefTypes(),
        this.fetchSubRefTypes(),
        this.fetchBranches(),
        this.fetchMembers(),
      ]);
      this.$store.commit("claimsV2/SET_LOADING", false);
    },
    onPageChange(page) {
      this.fetchAllData(page, this.pagination.size, this.activeTabValue);
    },
    onPageSizeChange(size) {
      this.fetchAllData(1, size, this.activeTabValue);
    },
    onTabChange() {
      this.fetchAllData(1, this.pagination.size, this.activeTabValue);
    },
    filteredClaims() {
      // No need to filter by status here, backend already does it
      let filtered = this.claims;
      if (this.search) {
        const s = this.search.toLowerCase();
        filtered = filtered.filter((claim) => {
          const ref = this.formatAasbRef(claim.caseId).toLowerCase();
          return ref.includes(s);
        });
      }
      if (this.filterStatus !== null && this.filterStatus !== undefined) {
        filtered = filtered.filter(
          (claim) => claim.isApproved === this.filterStatus
        );
      }
      if (this.filterDate) {
        filtered = filtered.filter((claim) =>
          moment(claim.createdAt).isSame(this.filterDate, "day")
        );
      }
      return filtered;
    },
    async fetchCasefiles() {
      try {
        const response = await CasefileDataService.getAll();
        this.casefiles = response.data || [];
      } catch (e) {
        this.casefiles = [];
      }
    },
    async fetchRefTypes() {
      try {
        const response = await DeptDataService.getAll();
        this.refType = response.data || [];
      } catch (e) {
        this.refType = [];
      }
    },
    async fetchSubRefTypes() {
      try {
        const response = await SubRefTypeDataService.getAll();
        this.subRefTypes = response.data || [];
      } catch (e) {
        this.subRefTypes = [];
      }
    },
    async fetchBranches() {
      try {
        const response = await BranchDataService.getAll();
        this.branches = (response.data || []).map(this.getDisplayBranch);
      } catch (e) {
        this.branches = [];
      }
    },
    async fetchMembers() {
      try {
        const response = await MemberDataService.getAll();
        this.members = (response.data || []).filter((item) =>
          item.roles.some((b) => b.roleCode === "adjuster")
        );
      } catch (e) {
        this.members = [];
      }
    },
    getDisplayBranch(branch) {
      return {
        id: branch.id,
        name:
          branch.name && branch.name.length > 30
            ? branch.name.substr(0, 30) + "..."
            : branch.name,
        brCode:
          branch.brCode && branch.brCode.length > 30
            ? branch.brCode.substr(0, 30) + "..."
            : branch.brCode,
      };
    },
    // ...existing code...
    filterCase(item) {
      return this.casefiles.filter((casefile) => casefile.id === item);
    },
    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      return this.subRefTypes.filter((subDept) => subDept.id === item);
    },
    filterBranches(item) {
      return this.branches.filter((branch) => branch.id === item);
    },
    filterUser(item) {
      return this.members.filter((member) => member.id === item);
    },
    total(itemId) {
      const thisclaim = this.claims.filter((claim) => claim.id === itemId);
      const total = thisclaim.reduce(
        (sum, row) =>
          sum +
          Number(row.travMileage || 0) +
          Number(row.additional || 0) +
          Number(row.sdAndStamps || 0) +
          Number(row.medicalReport || 0) +
          Number(row.policeDoc || 0) +
          Number(row.jpjDoc || 0) +
          Number(row.misc || 0) +
          Number(row.typing || 0),
        0
      );
      return total.toFixed(2);
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY LT");
    },
    yearOnly(value) {
      return moment(value).format("YY");
    },
    showItem() {
      // Placeholder for future detail dialog or navigation
      // this.$router.push({ name: "claimDetailsV2", params: { id: item.id } });
    },
    // --- New: Format AASB Reference as AA/{department}/{type}/{id}/{year}/{suffix}
    formatAasbRef(caseId) {
      const casefile = this.casefileMap[caseId];
      if (!casefile) return "";
      const dept = this.deptMap[casefile.refType];
      const subDept = this.subDeptMap[casefile.subRefType];
      const branch = this.branchMap[casefile.branch];
      // Fallbacks for missing data
      const deptCode = dept?.name || "DEPT";
      const subCode = subDept?.subCode || "TYPE";
      const id = casefile.id;
      const year = this.yearOnly(casefile.createdAt);
      const suffix = branch?.brCode || "SUF";
      return `AA/${deptCode}/${subCode}/${id}/${year}/${suffix}`;
    },
    // --- New: Status badge color
    statusColor(status) {
      switch (status) {
        case 0:
          return "primary";
        case 1:
          return "#FBC02D";
        case 2:
          return "#43A047";
        case 3:
          return "#1976D2";
        case 4:
          return "#E53935";
        default:
          return "grey";
      }
    },
    // --- New: Status label
    statusLabel(status) {
      switch (status) {
        case 0:
          return "New";
        case 1:
          return "Query";
        case 2:
          return "Approved";
        case 3:
          return "Pending";
        case 4:
          return "Rejected";
        default:
          return "Unknown";
      }
    },
    // --- New: Alternating row background
    getRowClass(item, index) {
      return index % 2 === 0 ? "bg-white" : "bg-grey lighten-4";
    },
    onRowClick(item) {
      this.selectedClaim = item;
      this.detailsDialog = true;
    },
    dummyAction(action) {
      // Dummy handler for action buttons
      this.$emit("action", action, this.selectedClaim);
      this.detailsDialog = false;
      // Optionally show a snackbar or notification here
    },
    dummyActionFromTable(action, item) {
      // Dummy handler for table action buttons
      this.$emit("action", action, item);
      // Optionally show a snackbar or notification here
    },
  },
  watch: {
    activeTab() {
      this.onTabChange();
    },
  },
};
</script>

<style scoped>
.bg-white {
  background: #fff !important;
}
.bg-grey {
  background: #f5f7fa !important;
}
.v-data-table .v-data-table__wrapper tr {
  transition: background 0.2s;
}
.v-data-table .v-data-table__wrapper tr:hover {
  background: #e3f2fd !important;
}
.compact-breadcrumb-row {
  min-height: 0 !important;
  margin-bottom: 0.25rem !important;
}
.compact-breadcrumb {
  min-height: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.compact-breadcrumb-text {
  font-size: 0.85rem !important;
  line-height: 1.2 !important;
  padding: 0 2px !important;
}
</style>
